import React from 'react'
import PropTypes from 'prop-types'

import loaderIcon from 'images/preloader_big_new.gif'

function Loader({ isFullHeight = false, className = null }) {
  const loaderHeightClassName = isFullHeight ? 'loader--full-height' : 'loader--fixed-height'

  return (
    <div className={`loader ${loaderHeightClassName} ${className}`}>
      <div className="loader__content-wrapper">
        <img src={loaderIcon} alt="Loading..." />
      </div>
    </div>
  )
}

Loader.propTypes = {
  isFullHeight: PropTypes.bool,
  className: PropTypes.string,
}

export default Loader
